import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import { getRemoveFromMongo } from "store/HistoricalData/actions";
import RemoveFromMongoPop from "components/Modals/removeFromMongoPop/removeDataMongoPop";

const List = () => {
  const dispatch = useDispatch();

  const { loading, removeFromMongoSetting, totalCount } = useSelector(
    ({ HistoricalData }) => ({
      loading: HistoricalData?.loading,
      removeFromMongoSetting: HistoricalData?.removeFromMongoSetting,
      totalCount: HistoricalData?.totalCount,
    }),
  );

  const [columns, setColumns] = useState([{ dataField: "", text: "" }]);
  const [removeFomMongo, setRemoveFromMongo] = useState(false);
  const [id, setId] = useState(false);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    orderBy: "date",
    order: 1,
    startDate: "",
    endDate: "",
    status: "",
  });

  const initialValuesForFilter = {
    search: "",
    startDate: "",
    endDate: "",
    status: "",
  };

  const inputFieldsForSearch = [
    {
      name: "startDate",
      type: "date",
      label: "",
      placeholder: "Start Date",
    },
    {
      name: "endDate",
      type: "date",
      label: "",
      placeholder: "End Date",
    },
    {
      name: "status",
      type: "select",
      label: "",
      placeholder: "Select Status",
      options: [
        { value: "", label: "All" },
        { value: "success", label: "Success" },
        { value: "partial", label: "Partial" },
        { value: "failed", label: "Failed" },
        { value: "pending", label: "Pending" },
      ],
    },
  ];

  useEffect(() => {
    getApiData(filter);
    setColumns(Columns({ handleViewHandler }));
  }, [filter]);

  const getApiData = () => {
    try {
      // Build payload — omit empty fields
      const payload = {
        page: filter.page,
        limit: filter.limit,
        orderBy: filter.orderBy,
        order: filter.order,
        ...(filter.startDate && { startDate: filter.startDate }),
        ...(filter.endDate && { endDate: filter.endDate }),
        ...(filter.status && { status: filter.status }),
      };
      dispatch(getRemoveFromMongo({ data: payload }));
    } catch (error) {}
  };

  const handleViewHandler = (info) => {
    setRemoveFromMongo(true);
    setId(info?._id);
  };

  const handleFilterForm = (info) => {
    setFilter((prev) => ({
      ...prev,
      page: 1,
      startDate: info.startDate || "",
      endDate: info.endDate || "",
      status: info.status || "",
    }));
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}

      {removeFomMongo && (
        <RemoveFromMongoPop
          show={removeFomMongo}
          handleClose={() => {
            setRemoveFromMongo(false);
            setId(null);
          }}
          title={"Energy Purchase History Details"}
          id={id}
        />
      )}

      <section className="section">
        <div className="section-header">
          <h1>Delete Data List From Mongo</h1>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={inputFieldsForSearch}
                    buttonText={"Search"}
                  />
                </div>
              </div>
            </div>
          </div>

          {!loading && removeFromMongoSetting?.length > 0 && (
            <Table
              data={removeFromMongoSetting}
              columns={columns}
              total={totalCount}
              filter={filter}
              setFilter={setFilter}
            />
          )}

          {!loading && (!removeFromMongoSetting || totalCount === 0) && (
            <p style={{ textAlign: "center" }}>No Data Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
